import * as plume from '@ulule/owl-kit-components/next'

export function footerBreakpoint(locale: string) {
    return locale === 'fr' ? plume.BREAKPOINTS.LAPTOP : plume.BREAKPOINTS.TABLET
}
